<template>
  <div class="modal fade" id="AddCompteEntrepriseModal" tabindex="-1" role="dialog" ref="addCompteEntrepriseModalRef"
    aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close" @click="resetValue"></button>
        </div>
        <div class="modal-body">
          <Form ref="compteEntrepriseForm" @submit="addCompteEntreprise" :validation-schema="compteEntrepriseSchema">
            <div class="row">
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Intitulé compte <span class="text-danger">*</span>
                  </label>
                  <Field name="intituleCompteEnt" type="text"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'intitulé du compte" />
                  <ErrorMessage name="intituleCompteEnt" class="text-danger" />
                </div>
              </div>
             <!--  <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Solde initial <span class="text-danger">*</span>
                  </label>
                  <Field name="soldeInitialCompteEnt" type="number"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le solde initial" />
                  <ErrorMessage name="soldeInitialCompteEnt" class="text-danger" />
                </div>
              </div>-->
             <!-- <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Solde actuel <span class="text-danger">*</span>
                  </label>
                  <Field name="soldeActuelCompteEnt" type="number"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le solde actuel" />
                  <ErrorMessage name="soldeActuelCompteEnt" class="text-danger" />
                </div>
              </div>-->
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Type de compte <span class="text-danger">*</span>
                  </label>
                  <Field name="typeCompte" v-slot="{ field }">
                    <Multiselect :searchable="true" :options="typeCompteOptions" v-model="typeCompte" v-bind="field"
                      placeholder="Sélectionner le type de compte" @input="onTypeCompteChange" />
                  </Field>
                  <ErrorMessage name="typeCompte" class="text-danger" />
                </div>
              </div>
              <!-- Champs pour Compte Bancaire -->
              <div class="col-md-6 mb-3" v-if="showBanqueField">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Banque <span class="text-danger">*</span>
                  </label>
                  <Field name="banque" v-slot="{ field }">
                    <Multiselect v-model="banque" v-bind="field" :options="banqueOptions" :preserve-search="true"
                      :searchable="true" placeholder="Sélectionner une banque" label="label" track-by="value" />
                  </Field>
                  <ErrorMessage name="banque" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 mb-3" v-if="showNumCompteField">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Numéro de compte <span class="text-danger">*</span>
                  </label>
                  <Field name="numeroCompteEnt" type="text" v-model="numeroCompteEnt"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le numéro de compte" />
                  <ErrorMessage name="numeroCompteEnt" class="text-danger" />
                </div>
              </div>
              <!-- Champ pour Compte Mobile Money -->
              <div class="col-md-12 mb-3" v-if="showTelephoneMoMoField">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Numéro de téléphone Mobile Money <span class="text-danger">*</span>
                  </label>
                  <Field name="telephoneMoMo" v-slot="{ field }">
                    <VueTelInput 
                      v-model="telephoneMoMo" 
                      v-bind="field"
                      defaultCountry="BJ" 
                      mode="international" 
                      @validate="validateMoMo"
                      :inputOptions="{ placeholder: 'Entrer le numéro de téléphone', required: true }"
                      class="shadow-none fs-md-15 text-black py-2" 
                    />
                  </Field>
                  <div v-if="!validPhoneMoMo && telephoneMoMo" class="text-danger">Veuillez entrer un numéro correct</div>
                  <ErrorMessage name="telephoneMoMo" class="text-danger" />
                </div>
              </div>
              <div class="col-md-12">
                <button class="btn btn-primary" type="submit">
                  {{ btntext }}
                </button>
                <button class="btn btn-secondary ms-2" type="button" @click="resetValue" data-bs-dismiss="modal">
                  Annuler
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, computed } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { hideModal } from '@/utils/utils';
import { CompteEntreprise } from '@/models/CompteEntreprise';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import { VueTelInput } from 'vue3-tel-input';

export default defineComponent({
  name: "AddCompteEntrepriseModal",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    VueTelInput,
  },
  props: {
    item: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    // Références réactives
    const compteEntrepriseForm = ref<any>(null);
    const addCompteEntrepriseModalRef = ref<HTMLElement | null>(null);
    const router = useRouter();
    const isUPDATE = ref(false);
    const title = ref("Ajouter une tésoreie");
    const btntext = ref('Ajouter');
    const typeCompte = ref<string | null>(null);
    const banque = ref<number | null>(null);
    const numeroCompteEnt = ref<string>('');
    const telephoneMoMo = ref<string>('');
    const validPhoneMoMo = ref<boolean>(false);
    const banqueOptions = ref<any[]>([]);

    // Options statiques pour le type de compte
    const typeCompteOptions = [
      { value: 'Compte Bancaire', label: 'Compte Bancaire' },
      { value: 'Compte Mobile Money', label: 'Compte Mobile Money' },
      { value: 'Compte Caisse', label: 'Compte Caisse' },
    ];

    // Contrôle de l'affichage des champs
    const showBanqueField = ref(false);
    const showNumCompteField = ref(false);
    const showTelephoneMoMoField = ref(false);

    // Schéma de validation dynamique
    const compteEntrepriseSchema = computed(() => {
      const schema: any = {
        intituleCompteEnt: Yup.string().required("L'intitulé du compte est obligatoire"),
        // soldeInitialCompteEnt: Yup.number()
        //   .typeError("Veuillez entrer un nombre")
        //   .required("Le solde initial est obligatoire")
        //   .min(0, "Le solde initial ne peut pas être négatif"),
        // //soldeActuelCompteEnt: Yup.number()
        //   .typeError("Veuillez entrer un nombre")
        //   .required("Le solde actuel est obligatoire")
        //   .min(0, "Le solde actuel ne peut pas être négatif"),
        typeCompte: Yup.string().required("Le type de compte est obligatoire"),
      };

      if (showBanqueField.value) {
        schema.banque = Yup.number()
          .required("La banque est obligatoire")
          .typeError("Veuillez sélectionner une banque");
        schema.numeroCompteEnt = Yup.string().required("Le numéro de compte est obligatoire");
      }

      if (showTelephoneMoMoField.value) {
        schema.telephoneMoMo = Yup.string()
          .required("Le numéro de téléphone Mobile Money est obligatoire")
          .min(12, "Le numéro doit inclure le code pays et être complet (ex. +229XXXXXXXX)")
          .test("valid-phone", "Veuillez entrer un numéro valide", () => validPhoneMoMo.value);
      }

      return Yup.object().shape(schema);
    });

    // Charger les banques
    const getAllBanques = async () => {
      try {
        const response = await ApiService.get('/banques');
        banqueOptions.value = response.data.data.map((banque: any) => ({
          value: banque.id,
          label: banque.denominationBanque,
        }));
      } catch (err) {
        error("Erreur lors de la récupération des banques");
      }
    };

    // Gestion du changement de type de compte
    const onTypeCompteChange = (value: string) => {
      typeCompte.value = value;
      showBanqueField.value = value === 'Compte Bancaire';
      showNumCompteField.value = value === 'Compte Bancaire';
      showTelephoneMoMoField.value = value === 'Compte Mobile Money';

      // Réinitialiser les champs non pertinents
      if (value === 'Compte Bancaire') {
        telephoneMoMo.value = '';
        validPhoneMoMo.value = false;
      } else if (value === 'Compte Mobile Money') {
        banque.value = null;
        numeroCompteEnt.value = '';
      }
    };

    // Validation du numéro de téléphone Mobile Money (intégrée depuis AddClient)
    const validateMoMo = (phoneObject: any) => {
      console.log("Validation téléphone MoMo :", phoneObject);
      validPhoneMoMo.value = phoneObject.valid === true;
      if (phoneObject.valid) {
        telephoneMoMo.value = phoneObject.number; // Numéro complet avec code pays (ex. +22912345678)
      } else {
        telephoneMoMo.value = ''; // Réinitialiser si invalide
      }
    };

    // Récupérer les données pour modification
    const getCompteEntreprise = async (id: number) => {
      try {
        const { data } = await ApiService.get(`/comptes-entreprise/${id}`);
        console.log("Données récupérées :", data.data);
        const donnees = data.data;

        // Pré-remplir les champs
        compteEntrepriseForm.value.setValues({
          id: donnees.id,
          intituleCompteEnt: donnees.intituleCompteEnt,
          //soldeInitialCompteEnt: donnees.soldeInitialCompteEnt,
          //soldeActuelCompteEnt: donnees.soldeActuelCompteEnt,
          typeCompte: donnees.typeCompte,
          banque: donnees.banque,
          numeroCompteEnt: donnees.numeroCompteEnt,
          telephoneMoMo: donnees.telephoneMoMo || '',
        });

        // Mettre à jour les variables réactives
        typeCompte.value = donnees.typeCompte;
        banque.value = donnees.banque || null;
        numeroCompteEnt.value = donnees.numeroCompteEnt || '';
        telephoneMoMo.value = donnees.telephoneMoMo || '';
        validPhoneMoMo.value = !!donnees.telephoneMoMo && donnees.telephoneMoMo.length >= 12;

        onTypeCompteChange(donnees.typeCompte); // Mettre à jour les champs affichés
        emit('openmodal', addCompteEntrepriseModalRef.value);
      } catch ({ response }) {
        error(response?.data?.message || "Erreur lors de la récupération des données");
      }
    };

    // Ajouter ou modifier un compte
    const addCompteEntreprise = async (values: any, { resetForm }: any) => {
      console.log("Valeurs envoyées :", values);
      try {
        const payload: any = {
          intituleCompteEnt: values.intituleCompteEnt,
          //soldeInitialCompteEnt: values.soldeInitialCompteEnt,
          //soldeActuelCompteEnt: values.soldeActuelCompteEnt,
          typeCompte: values.typeCompte,
        };

        if (showBanqueField.value) {
          payload.banque = values.banque;
          payload.numeroCompteEnt = values.numeroCompteEnt;
        }
        if (showTelephoneMoMoField.value) {
          payload.telephoneMoMo = telephoneMoMo.value; // Utiliser la valeur réactive validée
        }
        if (isUPDATE.value) payload.id = values.id;

        const response = isUPDATE.value
          ? await ApiService.put(`/comptes-entreprise/${values.id}`, payload)
          : await ApiService.post("/comptes-entreprise", payload);

        console.log("Réponse API :", response.data);

        if (response.data.code === (isUPDATE.value ? 200 : 201)) {
          success(response.data.message);
          resetForm();
          hideModal(addCompteEntrepriseModalRef.value);
          isUPDATE.value = false;
          btnTitle();
          emit('close');
        } else {
          error("Une erreur inattendue est survenue");
        }
      } catch (err) {
        console.error("Erreur :", err);
        error(err.response?.data?.message || "Erreur lors de l'enregistrement");
      }
    };

    // Mettre à jour le titre et le texte du bouton
    const btnTitle = () => {
      title.value = isUPDATE.value ? "Modifier une trésorerie" : "Ajouter une trésorerie";
      btntext.value = isUPDATE.value ? "Modifier" : "Ajouter";
    };

    // Réinitialiser le formulaire
    const resetValue = () => {
      isUPDATE.value = false;
      typeCompte.value = null;
      banque.value = null;
      numeroCompteEnt.value = '';
      telephoneMoMo.value = '';
      validPhoneMoMo.value = false;
      showBanqueField.value = false;
      showNumCompteField.value = false;
      showTelephoneMoMoField.value = false;
      compteEntrepriseForm.value?.resetForm();
      btnTitle();
    };

    // Surveiller les changements de l'ID pour modification
    watch(() => props.item, (newValue) => {
      if (newValue) {
        getCompteEntreprise(newValue);
        isUPDATE.value = true;
        btnTitle();
      }
    });

    onMounted(() => {
      getAllBanques();
    });

    return {
      compteEntrepriseSchema,
      addCompteEntrepriseModalRef,
      addCompteEntreprise,
      compteEntrepriseForm,
      title,
      btntext,
      resetValue,
      typeCompte,
      banque,
      numeroCompteEnt,
      telephoneMoMo,
      validPhoneMoMo,
      showBanqueField,
      showNumCompteField,
      showTelephoneMoMoField,
      banqueOptions,
      typeCompteOptions,
      validateMoMo,
      onTypeCompteChange,
    };
  },
});
</script>